// import { defaultNS, useTranslation } from "@/lib/i18n";
import { useState } from "react";

import Combobox from "@/components/Combobox";
import { useDebouncedCallback } from "@/hooks/useDebouncedCallback";
import type { ValueToLabelCache } from "@/hooks/useValueToLabelCache";

import { useDepartments } from "./-query";
import type { DepartmentOption } from "./-query/type";

interface DepartmentComboboxProps {
  value: string | null;
  onValueChange: (value: string | null, option?: DepartmentOption) => void;
  valueToLabelCache: ValueToLabelCache;
  excludeIds?: string[];
  label?: string;
}

export const DepartmentCombobox = ({
  value,
  onValueChange,
  valueToLabelCache,
  excludeIds = [],
}: DepartmentComboboxProps) => {
  // const { t } = useTranslation(defaultNS, {
  //   keyPrefix: "pages.people.settings.departments.filter.rootDepartment",
  // });

  const [searchText, setSearchText] = useState("");
  const debouncedSetSearchText = useDebouncedCallback(
    (text: string) => setSearchText(text),
    [],
  );

  const { data: options, isLoading } = useDepartments(searchText, excludeIds);

  const handleValueChange = (newValue: string | null) => {
    const option = options?.find((option) => option.value === newValue);
    onValueChange(newValue, option);
  };

  return (
    <Combobox<DepartmentOption>
      type="single"
      value={value}
      options={options}
      isFetching={isLoading}
      onValueChange={handleValueChange}
      // searchPlaceholder={t("searchPlaceholder")}
      onSearchChange={debouncedSetSearchText}
      valueToLabelCache={valueToLabelCache}
    />
  );
};
